import { FC, ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '@fe-learner-common/utils';

type LoaderProps = {
  isLoading: boolean;
  children: ReactNode;
  skeleton: ReactNode;
  className?: string;
};

export const Loader: FC<LoaderProps> = ({
  isLoading,
  children,
  skeleton,
  className,
}) => {
  const fade = { duration: 0.3, ease: 'easeInOut' } as const;

  return (
    <AnimatePresence mode="popLayout">
      {isLoading && (
        <motion.div
          key="skeleton"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={fade}
          className={cn('w-full', className)}
        >
          {skeleton}
        </motion.div>
      )}

      {!isLoading && (
        <motion.div
          key="content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 1 }}
          transition={fade}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
